package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

@Serializable
internal data class CachedBox(
    val south: Double,
    val west: Double,
    val north: Double,
    val east: Double,
)
